import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ISalesCycle} from '../../shared/model/salesCycle.model';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';


type EntityResponseType = HttpResponse<ISalesCycle>;
type EntityArrayResponseType = HttpResponse<ISalesCycle[]>;

@Injectable({providedIn: 'root'})
export class SalesCycleService {
  public resourceUrl = SERVER_API_URL + 'api/salesCycles';

  constructor(protected http: HttpClient) {
  }

  create(salesCycle: ISalesCycle): Observable<EntityResponseType> {
    return this.http.post<ISalesCycle>(this.resourceUrl, salesCycle, {observe: 'response'});
  }

  update(salesCycle: ISalesCycle): Observable<EntityResponseType> {
    return this.http.put<ISalesCycle>(this.resourceUrl, salesCycle, {observe: 'response'});
  }

  reform(salesCycle: ISalesCycle): Observable<EntityResponseType> {
    return this.http.put<ISalesCycle>(this.resourceUrl+'-reform', salesCycle, {observe: 'response'});
  }

  searchReportByTypeDaily(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISalesCycle[]>(this.resourceUrl + '-search-report-last', {params: options, observe: 'response'});
  }

  searchReportByTypeDailyStatus(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISalesCycle[]>(this.resourceUrl + '-search-report-last-status', {params: options, observe: 'response'});
  }

  searchDailyWithDetail(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISalesCycle[]>(this.resourceUrl + '-search-report-last-daily', {params: options, observe: 'response'});
  }

  searchDailyWithDetailAndStatus(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISalesCycle[]>(this.resourceUrl + '-search-report-last-status-daily', {params: options, observe: 'response'});
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<ISalesCycle>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISalesCycle[]>(this.resourceUrl, {params: options, observe: 'response'});
  }
  searchAdvanced(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISalesCycle[]>(this.resourceUrl + '-search-advanced', {params: options, observe: 'response'});
  }

  findWithCustomerId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISalesCycle[]>(this.resourceUrl + '-customer/'+id, {params: options, observe: 'response'});
  }

  // findByStatus(req?: any, status?:any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http.get<ISalesCycle[]>(this.resourceUrl + '-list-status/'+status, {params: options, observe: 'response'});
  // }

  findByStatus(req?: any, status?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISalesCycle[]>(this.resourceUrl+'-list-status/'+status, {params: options, observe: 'response'});
  }


  checkFOrArchive(id?:any): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<ISalesCycle[]>(this.resourceUrl+'-check-archive/'+id, {params: null, observe: 'response'});
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }


  querySendNotify(req?: any): Observable<HttpResponse<ISalesCycle[]>> {
    const options = createRequestOption(req);

    return this.http.get<any>(this.resourceUrl+'-send-notify', { params: options, observe: 'response' });
  }

  findSalesCycleNoFollowUpCount(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-noFollowUp-count'}`, {  observe: 'response' });
  }

}
